(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calculator-stepper"] && !Shopify.designMode) return;
  try {
    (function () {
    function fill(range) {
      var min = parseFloat(range.min) || 0;
      var max = parseFloat(range.max) || 100;
      var value = parseFloat(range.value) || 0;
      var share = max > min ? ((value - min) / (max - min)) * 100 : 0;
      range.style.setProperty('--calculator-range-fill', share + '%');
    }

    document.addEventListener('input', function (event) {
      if (event.target instanceof HTMLInputElement && event.target.matches('.calculator-range')) fill(event.target);
    });

    function init() {
      document.querySelectorAll('.calculator-range').forEach(fill);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

})();
